<!--
 * @Author: zxf
 * @Date: 2022-07-26 10:20:56
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:09:01
 * @Description: 维保计划列表
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        维保计划管理
      </h2>
      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          btn-text="新增"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleDialog('addPatch', {dlType: 'add', xmId: xmId})"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="计划时间"
                prop="jhsjQZ"
              >
                <hm-date-range
                  ref="dateRange"
                  v-model="filterParams.jhsjQZ"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="计划名称"
                prop="jhmc"
              >
                <el-input
                  v-model.trim="filterParams.jhmc"
                  class="c-form__input"
                  placeholder="请输入计划名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="状 态"
                prop="jhzt"
              >
                <el-select
                  v-model="filterParams.jhzt"
                  class="c-form__select"
                  placeholder="请选择状态"
                  clearable
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="(item,index) in jhztType"
                    :key="index"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #jhmc="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'viewWbjh', params: { id: scope.row.id } })"
              >
                {{ scope.row.jhmc }}
              </el-link>
            </template>

            <template
              #qzrq="scope"
            >
              {{ scope.row.jhsjQ || '-' | date("yyyy-MM-dd ") }} 至 {{ scope.row.jhsjZ|| '-' | date("yyyy-MM-dd ") }}
            </template>

            <el-table-column
              prop="enabled"
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
                  v-if="scope.row.jhztDm === 'WKS' || scope.row.jhztDm === 'DSC' || scope.row.jhztDm === 'ZXZ' "
                  btn-text="编辑"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="handleDialog('edit', {dlType: 'edit', id: scope.row.id})"
                />
                <k-button
                  v-if="scope.row.jhztDm === 'WKS' || scope.row.jhztDm === 'DSC' || scope.row.jhztDm === 'ZXZ' "
                  btn-text="删除"
                  :auth-type="true"
                  type="danger"
                  @click="handleDel(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>

      <div class="o-tips">
        已出过报告的维保计划不可删除
      </div>
    </div>
    <!-- 页面主内容：查询列表 End -->

    <!-- 新增/修改维保计划信息 -->
    <wbjh-update-dialog
      v-if="showDialogName==='add' || showDialogName==='edit'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <wbjh-save-dialog
      v-if="showDialogName==='addPatch'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>
<script>
import WbjhUpdateDialog from './updateDialog.vue';
import { wbjhService } from './wbjh.service.js';
import WbjhSaveDialog from './saveDialog.vue';
export default {
  name: 'WbjhList',
  components: {
    WbjhSaveDialog,
    WbjhUpdateDialog
  },
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      xmId: null, // 项目ID

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmId: null,
        jhzt: [],
        jhmc: null,
        jhkssjq: null, // 计划开始时间起
        jhkssjz: null, // 计划开始时间止
        jhsjQZ: [null, null]
      },
      /* 查询条件 end */
      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', label: '项目名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jhmc', slotName: 'jhmc', label: '计划名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'qzrq', slotName: 'qzrq', label: '计划起止日期', align: 'center', width: '200', type: 'date' },
        { key: 'jhztMc', label: '计划状态', align: 'left', width: '100', type: 'text' },
        // { key: 'lrdwMc', label: '录入单位', align: 'left', width: '200', type: 'text' },
        { key: 'cjsj', label: '创建时间', align: 'center', width: '140', type: 'dateTime' }
      ],
      /* 表格列配置End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */
    };
  },
  computed: {
    jhztType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_WBJH_STATUS) {
        return enums.IFF_WBJH_STATUS;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },

    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      [this.trueFilterParams.jhkssjq, this.trueFilterParams.jhkssjz] = this.trueFilterParams.jhsjQZ;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      wbjhService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm(`是否确认删除此计划：${_row.xmmc}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        wbjhService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.refreshSearch();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    }
  },
  created () {
    this.xmId = this.$route.params.xmId;
    this.filterParams.xmId = this.$route.params.xmId;
    if (this.$route.params.jhzt) {
      this.filterParams.jhzt = [this.$route.params.jhzt];
    }
    this.refreshSearch();
  },
  activated () {
    this.xmId = this.$route.params.xmId;
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }

};
</script>
<style lang="scss" scoped>
.dev-c-wbjh--header_button{
  margin-bottom: 10px;
}

.o-tips {
  position: absolute;
  top: 4px;
  right: 12px;
  z-index: 9;
  padding-left: 8px;
  border-left: 0;
  color: #f56c6c;
  background-color: #fef0f0;
}
</style>
